import { isNotNullOrUndefined } from './is-not-null-or-undefined';

export function getInverseDateSortValue(date: string | undefined): number {
    return isNotNullOrUndefined(date) ? Number.MAX_SAFE_INTEGER - new Date(date).getTime() : 0;
}
